import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { ExperienceDetailView } from "@/lib/features/ExperienceDetailView";
import { trpc } from "@/router";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Route = createFileRoute("/_app/upptack/$slug")({
  component: ExperienceDetailPage
});
function ExperienceDetailPage() {
  const $ = _c(6);
  const {
    slug
  } = Route.useParams();
  let t0;
  if ($[0] !== slug) {
    t0 = trpc.experiences.bySlug.queryOptions({
      slug
    });
    $[0] = slug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: experience,
    isLoading
  } = useQuery(t0);
  if (isLoading) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /*#__PURE__*/_jsx("div", {
        className: "flex min-h-[60vh] items-center justify-center",
        children: /*#__PURE__*/_jsx("div", {
          className: "h-8 w-8 animate-spin rounded-full border-4 border-brand/30 border-t-brand"
        })
      });
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  if (!experience) {
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /*#__PURE__*/_jsxs("div", {
        className: "flex min-h-[60vh] flex-col items-center justify-center gap-2 text-gray-500",
        children: [/*#__PURE__*/_jsx("p", {
          className: "text-lg font-medium",
          children: "Upplevelsen hittades inte"
        }), /*#__PURE__*/_jsx("p", {
          className: "text-sm",
          children: "Den kan ha tagits bort eller s\xE5 \xE4r l\xE4nken felaktig."
        })]
      });
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== experience) {
    t1 = /*#__PURE__*/_jsx(ExperienceDetailView, {
      experience: experience
    });
    $[4] = experience;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}